module.exports = __webpack_public_path__ + "static/img/icon512.19b1daa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorrope/icon512.jpg
// module id = /s45
// module chunks = 0